(() => {
  const isPDP = window.location.pathname.includes("/products/");
  if(isPDP) {
    document.addEventListener("click", e => {
        if (e.target.classList.contains("swatch-anchor")) {
          setTimeout(() => {
            const productForm = document.querySelector("[bss-b2b-main-product-form]");
            BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
          }, 800);
        }
    }, 1);
    
  setTimeout(() => {
    const titleElements = document.querySelectorAll(".spf-product-card__title > a");
  
    titleElements.forEach((titleEl) => {
      const productTitle = titleEl.textContent.trim();
    
      fetch('/search/suggest.json?q=' + encodeURIComponent(productTitle) + '&resources[type]=product')
        .then(response => response.json())
        .then(data => {
          if (data?.resources?.results?.products?.length > 0) {
            const productId = data.resources.results.products[0].id;
            console.log(`Product: ${productTitle} - ID: ${productId}`);
    
            const priceEle = titleEl.closest("[preorder-product-element]")?.querySelector(".spf-product-card__price");
            if (priceEle) {
              priceEle.setAttribute('bss-b2b-product-id', productId);
              priceEle.setAttribute('bss-b2b-product-price', '');
              if (typeof BSS_B2B !== "undefined") {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
              }
            }
          } else {
            console.warn(`No product found for: ${productTitle}`);
          }
        })
        .catch(error => {
          console.error("Error fetching product:", error);
        });
    });
  }, 800);

}

  const isCollection = window.location.pathname.includes("/collections/");
  if(isCollection) {
    document.addEventListener("click", e => {
        if (e.target.classList.contains("spf-product__swatch") || e.target.classList.contains("spf-product__swatch-inner") || e.target.classList.contains("spf-product__swatch-image")) {
          const closest = e.target.closest("[preorder-product-element]");
          const titleEle = closest.querySelector(".spf-product-card__title>a");
          productTitles = []
          productTitles.push(titleEle.textContent);
          const productPromises = productTitles.map(productTitle => {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(productTitle) + '&resources[type]=product')
        .then(response => response.json())
        .then(data => {
            if (data?.resources?.results?.products?.length > 0) {
                return {
                    title: productTitle,
                    productId: data.resources.results.products[0].id
                };
            } else {
                return {
                    title: productTitle,
                    productId: null,
                    message: 'No product found'
                };
            }
        })
        .catch(error => {
            return {
                title: productTitle,
                productId: null,
                error: 'Error fetching product data: ' + error
            };
        });
});

Promise.all(productPromises)
    .then(results => {
        results.forEach(result => {
            if (result.productId) {
                console.log(`Product Title: ${result.title} - Product ID: ${result.productId}`);
                setTimeout(() => {
                      const priceEle = closest.querySelector(".spf-product-card__price");
                    priceEle.setAttribute('bss-b2b-product-id', result.productId);
                  priceEle.setAttribute('bss-b2b-product-price', '');
                  BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                }, 500)
                
            } else {
                console.log(`Product Title: ${result.title} - Error or No product found: ${result.message || result.error}`);
            }
        });
    })
    .catch(error => {
        console.error('Error with Promise.all:', error);
    });
        }
    }, 1);
  }
})();